// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { lukso as _lukso } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the lukso chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 42
 * Chain Name: LUKSO
 * Default Block Explorer: https://explorer.execution.mainnet.lukso.network
 * Default RPC URL: https://rpc.mainnet.lukso.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { lukso } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: lukso,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const lukso = createCommon({
	..._lukso,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
